import script from "./LocationBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationBlock.vue?vue&type=script&setup=true&lang=ts"

import "./LocationBlock.vue?vue&type=style&index=0&id=1b117062&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b117062"]])

export default __exports__